import "./color.scss";

import * as React from "react";

export const Colors = ({colorsTileConfig}) => ({
    label: "Colors",
    render: () => <div className="line-chart-colors-7sv">{colorsTileConfig?.render()}</div>,
});
